/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *==================================================
 dportenis-producto-informacion
 */
//Standard libraries
import React, { useEffect, useState } from "react";
import TagManager from "react-gtm-module";

//UI
import {
  StyledGrid,
  StyledTypography,
  StyledPDPContainer,
  StyledTabs,
  PriceDisplay,
  StylediFrame,
  StyledCircularProgress,
} from "../../elements";
import GalleryProduct from "../../custom-widgets/GalleryProduct/GalleryProduct";
import PartnerDoubtsCards from "../../custom-widgets/PartnerDoubtsCards/PartnerDoubtsCards";
import styled from "styled-components";
import { SkuListWidget } from "../sku-list/sku-list-widget";
import { Box, makeStyles, CircularProgress } from "@material-ui/core";
import CenefaEnvioGratis from "../../custom/espot/CenefaEnvioGratis";

import * as componenteActions from "../../../redux/actions/componente";
import GTMDLService from "../../../_foundation/gtm/ua/gtmDataLayer.service";
import GA4GTMDLService from "../../../_foundation/gtm/ga4/gtmDataLayer.service";
import { useDispatch, useSelector } from "react-redux";
import Axios, { AxiosRequestConfig, Canceler } from "axios";
import noImageProduct from "../../../img/noImage.png";
import { useTheme } from "@material-ui/core/styles";
import { useMediaQuery } from "@material-ui/core";
import { useSite } from "../../../_foundation/hooks/useSite";
import ProductoElectronico, { DEFAULT_INFO_ELECTRONICO, InfoElectronico } from "./ProductoElectronico";
import { Electronicos } from "./Electronicos";
import { useTranslation } from "react-i18next";
import { cartSelector } from "../../../redux/selectors/order";

type ProductInformationWidgetProps = {
  productDetails: any;
  [extraProps: string]: any;
};

/**
 * B2B Product information display component
 * @description Displays product information ,prize ,image and other product details.
 * ` @prop { any } productDetails` The product details object has following properties:
 * ` @property { any } productData (required)` productData of product.
 * ` @property { object } translation (required)`  A object which holds multiple string values for transation purpose .
 * ` @property { any[] } promotion (required)` A map to hold state of associated promotions.
 * ` @property { any } productPartNumber (required)` The productPartNumber of product in string.
 * ` @property { string } productType (required)` A object which holds productType .
 * ` @property { number } productOfferPrice (required)` A number holds product offer prize .
 * ` @property { number } prodDisplayPrice (required)` A number holds product dispay prize .
 * ` @property {  ITabs[] } productDetailTabsChildren (required)` array of styled elements for productDetailTabsChildren.
 * ` @property {  object } currentProdSelect (required)` A object holds current selected product.
 * ` @property {  string } defaultCurrencyID (required)` A string holds default currency id.
 * ` @property {  string } language (required)` A string holds language id.
 * ` @property {  number } max (optional)` A number holds product max price.
 */

const styles = makeStyles((theme) => ({
  separador: {
    border: "0px solid #5E6977",
    width: "96%",
    margin: "-10px 24px 15px 24px",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      margin: "0px -10px 15px 0px",
    },
  },
  productDescription: {
    display: "block",
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  noImgClass: {
    width: "647px",
    height: "647px",
    [theme.breakpoints.down("xs")]: {
      width: "500px",
      height: "343px",
    },
  },
  containerImg: {
    textAlign: "center",
  },
}));

const CustomTabsContainer = styled.div`
  margin-top: 50px;
  width: 100%;

  .MuiAppBar-colorPrimary {
    background-color: unset;
  }
`;

const CustomPaymentsPlans = styled.div`
  font-family: Roboto, "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
  color: #333;
  font-size: 14px;
  text-transform: none;
  font-weight:normal;
  /*div{
    font-weight: 300 !important;
  }*/

  #payment-plans-dpvale {
    display: inline-flex;
    padding-top: 5px;
    align-items: center;
    font-weight: normal;
  }
  #payment-plans-dpvale{
    padding-top: 15px;
  }
  #payment-plans-dpvale img{
      height: 20px;
      width: auto;
      margin: 0 1px 0 4px;
  }
  #payment-plans-dpvale a{
    color: #2682E7;
    font-weight: 400;
    cursor: pointer;
  }
`;

/*Modal de planes de pago*/
const ModalPlanesDpvale = styled.div`
#content-plans-dpvale{
  font-family: Roboto, "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
  color: #333;
  font-size: 14px;
  text-transform: none;
  font-weight: 300;
}
  a.close-btn {
    cursor: pointer;
  }
  #modal-plans-dpvale {
    display:none;
    position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      min-height: 100vh;
      z-index: 999;
      justify-content: center;
      align-items: center;
  }
  #modal-plans-dpvale .fondo-plans-dpvale{
      position: fixed;
      width: 100%;
      height: 100%;
      background: #000;
      z-index: 999;
      opacity: .5;
      display: block;
  }
  #content-plans-dpvale {
    display: none;
      width: 599px;
      height: auto;
      border-radius: 6px !important;
      background: #fff !important;
      max-height: 90%;
      z-index: 999;
      border: none;
      top: 50%;
      left: 50%;
      position: fixed;
      overflow-y: auto;
      text-align: center;
      transform: translate(-50%, -50%);
  }
  #content-plans-dpvale.show{
    display: block !important;
  }
  #content-plans-dpvale > div {
      padding: 36px 40px !important;
  }
  #content-plans-dpvale .close-btn {
    position: absolute;
      top: 15px;
      right: 15px;
      width: 16px;
      height: 16px;
  }
  #content-plans-dpvale .plans-header {
      text-align: left;
  }
  #content-plans-dpvale #plans-title {
    display: inline-flex;
    align-items: center;
    text-align: left;
    font-size: 24px;
    font-weight: 800;
    letter-spacing: 0px;
    color: #2C2C2C;
    text-transform: uppercase;
  }
  #content-plans-dpvale #plans-title img {
    height: 30px;
      width: auto;
      margin: 0 0 0 8px;
  }
  #content-plans-dpvale .plans-description #promo-month{
    text-transform: uppercase;
  }
  #content-plans-dpvale .plans-description {
    font-size: 13px;
      line-height: 18px;
    text-align: left;
    color: black;
    /*font-weight: normal;*/
    margin-top: 12px;	
      font-family: 'Roboto';
      letter-spacing: 0px;
  }

  #content-plans-dpvale .warning-amount {
    font-size: 10px;
    line-height: 13px;
    text-align: left;
    color: black;
    margin-top: 6px;
    font-family: 'Roboto';
    letter-spacing: 0px;
    font-style: italic;
  }

  #content-plans-dpvale .primera-quincena {
    display: flex;
      margin-top: 15px;
      row-gap: 5px;
      align-items: center;
      column-gap: 3px;
      font-size: 13px;
      border-bottom: 1px solid #D9D9D9;
      padding-bottom: 15px;
  }
  #content-plans-dpvale .primera-quincena .fecha-pago{
      font-weight: bold;
  }

  #content-plans-dpvale .plans-table {
    margin-top: 20px;
    overflow: auto;	
  }
  #content-plans-dpvale .plans-table#special-promo{
      margin-top: 0px;
  }
  #content-plans-dpvale .plans-table#special-promo table{
    margin-top: 10px;
  }

  #content-plans-dpvale .plans-table#normal-promo table{
      border-top: 1px solid #D9D9D9;
  }

  #content-plans-dpvale .plans-table table{
    width: 100%;
    text-align: left;
  }
  #content-plans-dpvale .plans-table tbody tr:nth-child(odd) {
      background-color: #F7F7F7;
  }
  #content-plans-dpvale .plans-table tbody tr:nth-child(even) {
      background-color: #F1F1F1;
  }
  #content-plans-dpvale .plans-table thead th {
      padding: 15px 20px 8px 20px;
      font-size: 13px;
  }
  #content-plans-dpvale .plans-table tbody td {
      padding: 12px 20px;
      white-space: nowrap;
  }
  #content-plans-dpvale .plans-legend {
    margin-top: 10px;	
    font-size: 13px;
      line-height: 18px;
      text-align: center;
      color: #7B7B7B;
  }
  #content-plans-dpvale .plans-aviso a {
    font-style:italic;
    text-decoration: underline;
    color: #333;
  }
  #content-plans-dpvale .plans-aviso {
    line-height: 14px;
      text-align: center;
      margin-top: 10px;
      /*color: #7B7B7B;*/
      font-size: 10px;
      width: fit-content;
      font-family: 'Roboto';
  }

  @media only screen and (max-width: 600px), only screen and (max-device-width: 600px){
    #content-plans-dpvale{
      bottom: 0;
      top: unset;
      left: 0;
      width: 100%;
      max-height: 80%;
      transform: translateY(100%);
      transition: transform 0.3s ease-out;
    }
    #content-plans-dpvale.show{
      transform: translateY(0);
    }
    #content-plans-dpvale .plans-table tbody td {
      padding: 12px 15px;
    }
  }
`;

const CustomTitleProduct = styled.div`
  h4 {
    font-family: "Fjalla One";
    font-size: 32px;
    text-transform: uppercase;
    margin-bottom: 5px;
  }
`;

const CustomShortDescription = styled.div`
  font-family: "Roboto";
`;

const CustomPriceProduct = styled.div`
  font-size: 21px;
  color: #009894;
  font-weight: 400;
  display: block;
  line-height: 1em;
  font-family: "Fjalla One", sans-serif !important;
  text-transform: uppercase;
`;

export const ProductInformationWidget: React.FC<
  ProductInformationWidgetProps
> = ({ productDetails, ...props }) => {
  const productPartNumber = productDetails.productPartNumber;
  const translation = productDetails.translation;
  const productData = productDetails.productData;
  const promotion = productDetails.promotion;
  const productType = productDetails.productType;
  const productOfferPrice = productDetails.productOfferPrice;
  const prodDisplayPrice = productDetails.prodDisplayPrice;
  const productDetailTabsChildren = productDetails.productDetailTabsChildren;
  const currentProdSelect = productDetails.currentProdSelect;
  const currency = productDetails.defaultCurrencyID
    ? productDetails.defaultCurrencyID
    : "";
  const message = translation.productDetailPriceDisplayPending;
  const language = productDetails.language;
  const max = productDetails.max ? productDetails.max : null;
  const { mySite } = useSite();
  const [thumbnails, setThumbnails] = useState<any[]>([]);
  const [objOferta, setObjOferta] = useState<any>(null);
  const [normalPrice, setNormalPrice] = useState<any>(null);
  const [productoGanador, setProductoGanador] = useState<any>(null);
  const [atributosValidos, setAtributosValidos] = useState<any>([]);
  const [oferta, setOferta] = useState<any>(null);
  const [dpdOferta, setDpdOferta] = useState<any>(null);
  const [productoNuevo, setProductoNuevo] = useState<any>(null);
  const [tallasDisponibles, setTallasDisponibles] = useState<any>(null);
  const [thumbnailsLoaded, setThumbnailsLoaded] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [customProductCode, setCustomProductCode] = useState<any>("");
  const [promocionesDpvale, setPromocionesDpvale] = useState<any>(null);
  const [showModalPromociones, setShowModalPromociones] = useState<any>(false);
  const theme = useTheme();
  const xsWidth = useMediaQuery(theme.breakpoints.down("xs"));
  //Informacion de electronicos
  const [infoElectronico, setInfoElectronico] = useState<InfoElectronico>();
  const isElectronico = infoElectronico?.isElectronico
  const strikedPriceDeContado = productData ? productData["x_prices.field1"] : undefined;
  
  const classes = styles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const CancelToken = Axios.CancelToken;
  const source = CancelToken.source();


  useEffect(() => {
    //console.log("Termino de cargar")
    setPriceElectronicos()
    dispatch(
      componenteActions.setNombreComponente({ nombre: "product-information" })
    );

    return () => {
      dispatch(componenteActions.setNombreComponente({ nombre: "" }));
    };
  }, []);

  const cart = useSelector(cartSelector);

  useEffect(() => {
    //console.log("Termino de cargar infoElectronico")
    if(productDetails && infoElectronico){
      //Busca las promociones dpvale
      setPromocionesDpvale(null);
    }
  }, [infoElectronico,productDetails,cart]);

  useEffect(() => {
    if(promocionesDpvale == null){
      //Busca las promociones dpvale
      handleGetDpvalePromotions();
    }
  }, [promocionesDpvale]);

  useEffect(() => {
    getImagesID();
    getRibbonInfo(productData);
    setGA4();
    //console.log("Termino de cargar PDP, productDetails",productDetails)
    getProductCode();

    return () => {
      setThumbnails([]);
      setAtributosValidos([]);
      setProductoGanador(null);
    };
  }, []);

  /* 
    * Consulta el codigo del articulo
    */
  const getProductCode = async ()=> {
    const url = `/wcs/resources/store/${mySite.storeID}/GetCatentryField4/byId/${productData.id}`;
    //console.log("url GetCatentryField4",url)
    await Axios.get(url).then((data) => {
      //console.log("success GetCatentryField4",data.data?.field4);
      if(data.data?.field4 !== null)
        setCustomProductCode(data.data?.field4);
    }).catch((error) => {
      console.debug("error GetCatentryField4", error);
    });
  }


  /**
   * Recupera la informacion de los productos electronicos
   */
  async function setPriceElectronicos(){
    if(productData && !infoElectronico) {
      //Coleccion temporal de productos electronicos
      let newInfoElectronicos : Map<string,InfoElectronico> = new Map()
      const newElectronico = {
        isElectronico: undefined,
        hasOfferDeContado: productData["x_prices.field1"] ? true : false,
        prices: {
          offerDpVale: undefined,
          offerDeContado: undefined,
          strikedDeContado: productData["x_prices.field1"]
        }
      }
      newInfoElectronicos.set(productData.id, newElectronico)
      await Electronicos(mySite?.storeID, newInfoElectronicos,setInfoElectronicosCallback)
    }
  }

  function setInfoElectronicosCallback(newInfoElectronicos: Map<string,InfoElectronico>){
    const newInfoElectronico :InfoElectronico = newInfoElectronicos?.has(productData.id) ? newInfoElectronicos.get(productData.id)! : DEFAULT_INFO_ELECTRONICO
    setInfoElectronico(newInfoElectronico)
  }

  const setGA4 = () => {
    console.log("initGA4");
    let gender = productData.attributes.filter(
      (atribute) => atribute.identifier === "Genero"
    )[0]?.values[0]?.value;
    let family = productData.attributes.filter(
      (atribute) => atribute.identifier === "Familia"
    )[0]?.values[0]?.value;

    const tagManagerArgs = {
      gtmId: "GTM-MTWJ3H6",
    };

    TagManager.initialize(tagManagerArgs);

    TagManager.dataLayer({ dataLayer: { ecommerce: null } }); // Clear the previous ecommerce object.
    TagManager.dataLayer({
      dataLayer: {
        event: "view_item",
        ecommerce: {
          items: [
            {
              item_name: productData.name,
              item_id: productData.id, //Colocar el ID de producto real
              price: productData.price[1].value,
              item_brand: productData.manufacturer,
              item_category: family ? family : "",
              item_category2: gender ? gender : "",
              quantity: 1,
            },
          ],
        },
      },
    });
  };

  const getImagesID = () => {
    let productImages: any = [];
    if (productPartNumber !== "") {
      //setshowWindow(true);
      const partNum = productPartNumber
        .split("-")
        .slice(0, 2)
        .join("-")
        .substring(2);
      const prodImages: any = [
        `${partNum}V1.jpg`,
        `${partNum}V2.jpg`,
        `${partNum}V3.jpg`,
        `${partNum}V4.jpg`,
        `${partNum}V5.jpg`,
        `${partNum}V6.jpg`,
        `${partNum}V7.jpg`,
      ];

      function imageExists(url) {
        var http = new XMLHttpRequest();

        http.open("HEAD", url, false);
        http.send();

        return http.status;
      }

      prodImages.map((img) => {
        const url = `/wcsstore/ExtendedSitesCatalogAssetStore/images/catalog/thumbnail/${img}`;
        const exist = 200;
        if (exist === 200) {
          productImages.push(img);
        }
      });

      if (productImages.length === 0) {
        setThumbnailsLoaded(false);
      }

      setThumbnails(productImages);
      setIsLoading(false);
    }
  };

  const getRibbonInfo = (prodData) => {
    let arrayAtributes: any = [];
    prodData &&
      prodData.attributes.map((attribute: any, index: number) => {
        if (attribute.storeDisplay === "true") {
          if (
            !attribute.name.includes("DPT_") &&
            !attribute.name.includes("DPS_")
          ) {
            arrayAtributes.push(attribute);
          }
        } else if (attribute.name === "DPD_Producto Ganador") {
          setProductoGanador(attribute);
        }
      });

    if (prodData?.attributes && prodData.attributes.length > 0) {
      const resultOferta = prodData.attributes.filter(
        (atribute) => atribute.identifier === "Oferta"
      )[0];
      const resultPriceOferta = prodData.price.filter(
        (price) => price.usage === "Display"
      )[0];
      let dataOferta;
      let precioNormal = resultPriceOferta
        ? parseFloat(resultPriceOferta.value).toFixed(2)
        : null;
      if (
        resultOferta &&
        resultOferta?.values &&
        resultOferta.values.length > 0
      ) {
        dataOferta = {
          porcentaje: resultOferta.values[0].value,
          precioNormal: resultPriceOferta
            ? parseFloat(resultPriceOferta.value).toFixed(2)
            : null,
        };
      }
      setNormalPrice(precioNormal);
      setObjOferta(dataOferta);
    }
    setAtributosValidos(arrayAtributes);
  };
  const guia_tallas = (
    <div className="size-guide-content">
      <StylediFrame
        style={{
          width: "100%",
          maxWidth: "1280px",
          height: "auto",
          border: "none",
        }}
        src="https://www.dportenis.mx/wcsstore/AuroraStorefrontAssetStore/custom_paginas_estaticas/guia_de_tallas/guia_de_tallas_main.html"></StylediFrame>
    </div>
  );

  productDetailTabsChildren.push({
    title: "Guía de tallas",
    tabContent: guia_tallas,
  });

  window.addEventListener(
    "popstate",
    function (event) {
      localStorage.setItem("isBack", "true");
      window.isBack = true;
    },
    false
  );

  const InfoDpvalePlans = () => {
    return (
      <CustomPaymentsPlans>
        <div id="payment-plans-dpvale" className={`${isElectronico ? "electronico" : ""}`}>
          <span>¿Tienes un </span>
          <img src="https://dp-imagenes.s3.us-west-2.amazonaws.com/images/icons/dpvale-logo.png"/>
          <span>?&nbsp;</span>
          <a onClick={() => {setShowModalPromociones(true)}}>Ver planes de pago</a>
        </div>
      </CustomPaymentsPlans>
    )
  }

  const handleGetDpvalePromotions = async () => {
    console.debug("Consultando promociones dpvale",cart?.orderId)
    let params = {
      product:{
        amount: productOfferPrice,
        sku: productData?.partNumber
      },
      orderId: cart?.orderId,
    };
    let urlPromotions = `/wcs/resources/store/${mySite?.storeID}/dpvale/promotions`;
    Axios.post(urlPromotions, params, {validateStatus: () => true})
    .then((response) => {
      console.debug("response dpvale promotions",response?.data);
      //Si dio algun error
      if(response?.data?.errors && response?.data?.errors?.length > 0){
        const error = response?.data?.errors[0];
        let errorData: any = {};
        //Si supero el maximo
        if(error?.errorCode === "ERRDP006"){
          errorData.dpvaleAmountExceeded = true;
          errorData.maxAmount = error.errorParameters[1];
        }
        else {
          errorData.error = true;
        }
        errorData.showWarningAmount = false;
        console.debug("errorData",errorData)
        setPromocionesDpvale(errorData);
      }
      else if (response?.data?.data) {
        //Respondio correctamente
        const promos = response.data.data;
        promos.canShowSpecialPromo = promos?.cart ? promos?.cart?.hasElectronicos === false : !isElectronico
        //Valida el escenario actual
        promos.noPromos = promos?.normal.length === 0 && promos.special.length === 0;
        if(!promos.noPromos){
          promos.withCart = promos.cart?.grandTotal;
          promos.withProduct = !promos.withCart;
          promos.showWarningAmount = false;
        }
        //Warning de precio solo cuando si hayan promos
        promos.showWarningAmount = !promos.noPromos;
        promos.isProductInCart = promos.cart?.isProductInCart;
        console.debug("newPromocionesDpvale",promos)
        setPromocionesDpvale(promos);
      }
    })
    .catch(function (error) {
      console.debug("Error", error);
    });
  };

  return (
    <React.Fragment>
      {isLoading ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height={647}>
          <Box>
            <CircularProgress />
          </Box>
        </Box>
      ) : (
        <>
        <ModalPlanesDpvale>
          {/* Fondo negro del modal */}
          <div id="modal-plans-dpvale" style={{display: `${showModalPromociones ? "block": "none"}`}}>
            <div className="fondo-plans-dpvale" onClick={() => setShowModalPromociones(false)}></div>
          </div>
          {/* Contenido del modal */}
          <div id="content-plans-dpvale" className={`${showModalPromociones ? "show": ""}`}>
            <div>
              <a onClick={() => setShowModalPromociones(false)} className="close-btn" tabIndex={3}> 
                <img role="button" src="https://www.dportenis.mx/wcsstore/Widgets_801/images/close.svg" alt="CLOSE"/>
              </a>
              <div className="plans-header">
                <div id="plans-title">
                  <span>PLANES DE PAGO CON </span>
                  <img src="https://dp-imagenes.s3.us-west-2.amazonaws.com/images/icons/dpvale-logo.png"/>
                </div>
              </div>
              {promocionesDpvale == null ?
                <div style={{paddingTop:"10px"}}>
                  <StyledCircularProgress />
                </div>
              :
              <>
                {/* Descripciones del escenario actual */}
                <div className="plans-description" id="current-cart">
                  {/* Consulta por monto del carrito */}
                  {promocionesDpvale?.withCart &&
                      <span id="grand-total">
                        {"Tienes "}
                        <b id="cart-amount">
                          {new Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN", minimumSignificantDigits:1})
                          .format(Number(promocionesDpvale.cart?.grandTotal))}
                        </b>
                        {" en tu carrito"}
                        {!promocionesDpvale?.isProductInCart && <i>, agrega este producto para ver tu plan de pagos completo</i>}
                        {". Si "}<b>compras HOY</b>{" así quedarían tus pagos de acuerdo a las promociones vigentes:"}
                      </span>
                  }
                  {/* Consulta por monto del producto */}
                  {promocionesDpvale?.withProduct &&
                      <span id="empty-cart">
                        Agregando este producto a tu carrito y <b>comprando HOY</b>, así te quedarían tus pagos, de acuerdo a las promociones vigentes:
                      </span>
                  }
                  {/* No hay promos para el monto actual */}
                  {promocionesDpvale?.noPromos &&
                    <span id="no-promos">
                      No aplican promociones para el pago con tu dpvale.
                    </span>
                  }
                  {/* Monto maximo de dpvale */}
                  {promocionesDpvale?.dpvaleAmountExceeded &&
                    <span id="max-amount-dpvale">
                      {"El total de tu orden supera el monto máximo de "}
                      <b id="cart-amount"> 
                        {new Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN",})
                        .format(Number(promocionesDpvale?.maxAmount))}
                        {" pesos "}
                      </b>
                      {" que se tiene autorizado para pagar con un dpvale, revisa con tu distribuidor tu importe máximo autorizado de compra."}
                    </span>
                  }
                  {/* Error al hacer la peticion */}
                  {promocionesDpvale?.error &&
                  <span id="error-dpvale-plans">
                    Ha ocurrido un error consultando las promociones disponibles.
                  </span>
                  }
                </div>

                {/* Advertencia del precio dpvale */}
                {promocionesDpvale?.showWarningAmount &&
                <div className="warning-amount">
                  * Te recordamos que seleccionando dpvale como forma de pago, no aplican ciertas promociones, por lo que puede variar el monto de tu carrito y lo que te presentamos en este PLAN DE PAGOS.
                </div>
                }

                {/* Promocion de quincenas corridas */}
                {promocionesDpvale?.normal && promocionesDpvale?.normal.length > 0 &&
                  <div className="plans-table" id="normal-promo">
                    <table cellSpacing="0">
                      <thead>
                        <tr>
                          <th>Plazo</th>
                          <th>Quincenal</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td id="quincenas">
                            <span>
                              <b>{promocionesDpvale?.normal[0]?.quincenas}</b> quincenas
                            </span>
                          </td>
                          <td id="pagoQuincenal">
                            <span className="price_noMXN">
                              {new Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN",})
                              .format(Number(promocionesDpvale?.normal[0]?.pagoQuincenal))}
                            </span>
                          </td>
                          <td id="pagoTotal">
                            <b>
                              <span className="price_noMXN">
                                {new Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN",})
                                .format(Number(promocionesDpvale?.normal[0]?.pagoTotal))}
                              </span>
                            </b>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div className="primera-quincena">
                      <div>Empiezas a pagar el:</div>
                      <div className="fecha-pago">
                        {promocionesDpvale?.normal[0]?.paymentDate?.string}
                      </div>
                    </div>
                  </div>
                }
                
                {/* Promocion de compre hoy y pague hasta */}
                {promocionesDpvale?.special && promocionesDpvale?.special.length > 0 && promocionesDpvale?.canShowSpecialPromo &&
                  <div className="plans-table" id="special-promo">
                    <div className="plans-description">
                      <span>En caso de contar con la promoción <b>Compra HOY y PAGA HASTA</b> activa, así quedarían tus pagos. <i>Usando esta promoción aceptas el cargo por promoción establecida.</i>
                    </span></div>
                    <table cellSpacing="0">
                      <thead>
                        <tr>
                          <th>Plazo</th>
                          <th>Quincenal</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                        <td id="quincenas">
                            <span>
                              <b>{promocionesDpvale?.special[0]?.quincenas}</b> quincenas
                            </span>
                          </td>
                          <td id="pagoQuincenal">
                            <span className="price_noMXN">
                              {new Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN",})
                              .format(Number(promocionesDpvale?.special[0]?.pagoQuincenal))}
                            </span>
                          </td>
                          <td id="pagoTotal">
                            <b>
                              <span className="price_noMXN">
                                {new Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN",})
                                .format(Number(promocionesDpvale?.special[0]?.pagoTotal))}
                              </span>
                            </b>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    
                    <div className="primera-quincena">
                      <div>Empiezas a pagar el:</div>
                      <div className="fecha-pago">
                        {promocionesDpvale?.special[0]?.paymentDate?.string}
                      </div>
                    </div>
                  </div>
                }
              </>
              }
              <div className="plans-aviso">
                Los plazos disponibles y definitivos para tu compra, se activarán en base al monto total que pagues con tu dpvale, consulta términos y condiciones en: <i><a target="_blank" href="https://www.dpdirecto.mx/terminos-condiciones">https://www.dpdirecto.mx/terminos-condiciones</a></i>
              </div>
            </div>
				  </div>
        </ModalPlanesDpvale>
        <StyledPDPContainer
          itemScope
          itemType="http://schema.org/Product"
          id={`product-image-details_${productPartNumber}`}
          className="custom-container-product-detail">
          {/* <hr classN ame="separador"/> */}
          {/* <Box border={1} height={10} paddingTop={5} paddingBottom={5}> */}
          <input
            type="hidden"
            className={"product-sku"}
            value={productPartNumber}
          />
          <hr className={classes.separador} />

          {/* </Box> */}

          <StyledGrid container spacing={1}>
            <div id="content-personalization-product"></div>
            <StyledGrid
              item
              xs={12}
              sm={12}
              md={7}
              className={classes.containerImg}>
              {thumbnailsLoaded ? (
                <GalleryProduct
                  img="/wcsstore/ExtendedSitesCatalogAssetStore/images/catalog/zoom/1023376-0001V1.jpg"
                  thumbnails={thumbnails}
                  objOferta={oferta}
                  dpdOferta={dpdOferta}
                  productoNuevo={productoNuevo}
                  tallasDisponibles={tallasDisponibles}
                  productoGanador={productoGanador}
                  atributosValidos={atributosValidos}
                />
              ) : (
                <img src={noImageProduct} className={classes.noImgClass}></img>
              )}
            </StyledGrid>
            <StyledGrid item xs={12} sm={12} md={5}>
              <StyledGrid container spacing={1}>
                <StyledGrid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="model_code" style={{display:"flex"}}>
                    {isElectronico && <>
                      <span style={{fontFamily:"Roboto", fontSize:"16px",color:"#333",fontWeight:"300"}}>
                        Modelo: {productPartNumber}
                      </span>
                      {customProductCode !== "" &&
                      <>
                        <span id="modelCodeLimit"></span>
                        <span id={`product_CODE_${productData.id}`} style={{fontFamily:"Roboto", fontSize:"16px",color:"#333",fontWeight:"300"}}>
                          {t("productDetail.CODE", {
                            code: customProductCode,
                          })}
                        </span>
                      </>
                      }
                    </>}
                  </div>
                  {/*  Titulo del producto */}
                  <CustomTitleProduct>
                    <StyledTypography
                      variant="h1"
                      itemProp="name"
                      id={"Product_Name_Product_Details"}
                      className={"product-name custom-product-name"}
                      style={{marginTop:`${isElectronico ? "5px" : "16px"}`}}
                      >
                      {productData.name}
                    </StyledTypography>
                  </CustomTitleProduct>

                  {/*  Descripcion del producto 
                {promotion ? (
                  <StyledTypography
                    variant="body2"
                    id={`product_advertisement_${productPartNumber}`}
                    className="product-promo"
                    gutterBottom>
                    {promotion}
                  </StyledTypography>
                ) : null}*/}

                  <div
                    itemProp="offers"
                    itemScope
                    itemType="http://schema.org/Offer"
                    style={{ marginTop: "10px" }}>
                    {productType !== "bundle" ? (
                      <CustomPriceProduct>
                        <StyledTypography
                          variant={isElectronico ? "body2" : "h5"}
                          className="product-price-container">
                          {productOfferPrice > 0 && infoElectronico 
                            ?
                            <>
                              {isElectronico
                                ? 
                                  <ProductoElectronico {...{prices: {...infoElectronico.prices,offerDpVale: productOfferPrice, strikedDeContado: strikedPriceDeContado},
                                  promocionesDpvale, fromQuickInfo: false}} />
                                :
                                <span className="product-price">
                                  <div
                                    style={{
                                      color:
                                        parseFloat(prodDisplayPrice) >
                                        parseFloat(productOfferPrice)
                                          ? "red"
                                          : "",
                                    }}>
                                    {prodDisplayPrice > 0 &&
                                    parseFloat(prodDisplayPrice) >
                                      parseFloat(productOfferPrice)
                                      ? "OFERTA:"
                                      : "PRECIO:"}
                                    &nbsp;
                                    {new Intl.NumberFormat("es-MX", {
                                      style: "currency",
                                      currency: "MXN",
                                    }).format(Number(productOfferPrice))}
                                    &nbsp;MXN
                                  </div>
                                  <input
                                    id={"Product_Offer_Price"}
                                    type="hidden"
                                    className={`price-display`}
                                    value={Number(productOfferPrice)}
                                  />
                                </span>
                                }
                              </>
                              : 
                                null
                            }
                          {productOfferPrice === 0 && prodDisplayPrice === 0 ? (
                            <span
                              id={`product_offer_price_${productPartNumber}`}>
                              <PriceDisplay
                                {...{
                                  min: null,
                                  max,
                                  currency,
                                  message,
                                  language,
                                }}
                              />
                            </span>
                          ) : null}
                        </StyledTypography>
                        <StyledTypography
                          variant="h5"
                          className="product-price-container"
                          style={{
                            display: oferta
                              ? "block"
                              : oferta === undefined &&
                                parseFloat(prodDisplayPrice) >
                                  parseFloat(productOfferPrice)
                              ? "block"
                              : "none",
                          }}>
                          {prodDisplayPrice != productOfferPrice ? (
                            <span
                              className="product-price"
                              style={{
                                fontSize: 14,
                                color: "#000",
                                textDecoration: "line-through",
                              }}>
                              <div>
                                PRECIO:&nbsp;
                                {new Intl.NumberFormat("es-MX", {
                                  style: "currency",
                                  currency: "MXN",
                                }).format(Number(prodDisplayPrice))}
                                &nbsp;MXN
                              </div>
                            </span>
                          ) : oferta === undefined ? (
                            <span
                              className="product-price"
                              style={{
                                fontSize: 14,
                                color: "#000",
                                textDecoration: "line-through",
                              }}>
                              <div>
                                PRECIO:&nbsp;
                                {new Intl.NumberFormat("es-MX", {
                                  style: "currency",
                                  currency: "MXN",
                                }).format(Number(prodDisplayPrice))}
                                &nbsp;MXN
                              </div>
                            </span>
                          ) : null}
                        </StyledTypography>
                        {/* Custom product code */}
                        {isElectronico === false && customProductCode !== "" &&
                          <div className="sku-original">
                            {/* Aqui dportenis pone el sku padre (no aplica) */}
                            <span id={`product_CODE_${productData.id}`} className="sku code">
                              {t("productDetail.CODE", {
                                code: customProductCode,
                              })}
                            </span>
                          </div>
                        }
                        {/* Planes de pago con dpvale */}
                        <InfoDpvalePlans/>
                        <div
                          style={{
                            marginTop: "40px",
                            display: xsWidth ? "none" : "block",
                          }}>
                          <CenefaEnvioGratis espotName={"CenefaEnvioGratis"} />
                        </div>
                      </CustomPriceProduct>
                    ) : null}
                  </div>
                   {/* Short description */}
                  <Box my={4}>
                    <Box className={classes.productDescription}>
                      <CustomShortDescription>
                        <StyledTypography
                          variant="body1"
                          itemProp="description"
                          className="product-shortDescription">
                          {productData.shortDescription}
                        </StyledTypography>
                      </CustomShortDescription>
                    </Box>
                  </Box>
                </StyledGrid>

                {/* Tabla de SKUs y boton de agregar al carrito */}
                <StyledGrid item xs={12} sm={12} md={12} lg={12} xl={12} className={`${isElectronico ? "add2cart-container-electronico":""}`}>
                  <SkuListWidget
                    productDetails={productDetails}
                    isElectronico={isElectronico}
                    extraProps={props}
                  />
                </StyledGrid>
              </StyledGrid>
            </StyledGrid>
          </StyledGrid>
          <StyledGrid container justify="center">
            <CustomTabsContainer className="customTabsContainer">
              {productDetailTabsChildren?.length > 0 ? (
                <StyledTabs
                  childrenList={isElectronico ? productDetailTabsChildren.filter(item => item.title === 'Detalles del producto') : productDetailTabsChildren}
                  name="productDetails"
                />
              ) : null}
            </CustomTabsContainer>
          </StyledGrid>
          {/* CARDS PARTNERS AND DOUBTS */}
          <PartnerDoubtsCards
            loginNotRequired={productDetails.loginNotRequired}
          />
        </StyledPDPContainer>
        </>
      )}
    </React.Fragment>
  );
};
